import React, { useState } from 'react';

const Navigation: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className="bg-white shadow-sm border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <a href="/" className="text-xl sm:text-2xl font-serif text-brand-green-800 hover:text-brand-green-600 transition-colors shrink-0">
            <span className="hidden sm:inline">Healing with Hailey</span>
            <span className="sm:hidden">H.w.H</span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-6 xl:gap-8">
            <a href="/personalized" className="text-gray-600 hover:text-brand-green-600 transition-colors text-sm xl:text-base">
              1:1 Healing
            </a>
            <a href="/community" className="text-gray-600 hover:text-brand-green-600 transition-colors text-sm xl:text-base">
              Community
            </a>
            <a href="/catalog" className="text-gray-600 hover:text-brand-green-600 transition-colors text-sm xl:text-base">
              Resources
            </a>
            <a href="/software" className="text-gray-600 hover:text-brand-green-600 transition-colors text-sm xl:text-base">
              Software
            </a>
            <a href="/client" className="text-gray-600 hover:text-brand-green-600 transition-colors text-sm xl:text-base">
              Client Portal
            </a>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={toggleMobileMenu}
            className="lg:hidden p-2 rounded-md text-gray-600 hover:text-brand-green-600 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-brand-green-500 focus:ring-inset"
            aria-expanded={isMobileMenuOpen}
            aria-label="Toggle mobile menu"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              {isMobileMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Navigation Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 bg-white border-t border-gray-100">
              <a 
                href="/personalized" 
                className="block px-3 py-2 text-base font-medium text-gray-600 hover:text-brand-green-600 hover:bg-gray-50 rounded-md transition-colors"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                1:1 Healing
              </a>
              <a 
                href="/community" 
                className="block px-3 py-2 text-base font-medium text-gray-600 hover:text-brand-green-600 hover:bg-gray-50 rounded-md transition-colors"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Community
              </a>
              <a 
                href="/catalog" 
                className="block px-3 py-2 text-base font-medium text-gray-600 hover:text-brand-green-600 hover:bg-gray-50 rounded-md transition-colors"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Resources
              </a>
              <a 
                href="/software" 
                className="block px-3 py-2 text-base font-medium text-gray-600 hover:text-brand-green-600 hover:bg-gray-50 rounded-md transition-colors"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Software
              </a>
              <a 
                href="/client" 
                className="block px-3 py-2 text-base font-medium text-gray-600 hover:text-brand-green-600 hover:bg-gray-50 rounded-md transition-colors"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Client Portal
              </a>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
export { Navigation };